<template>
    <div class="ui input left icon">
        <i class="calendar icon"></i>
        <input type="text" :name="name" :placeholder="placeholder">
    </div>
</template>
<script>
  /**
   * Nota sobre este componente:
   * si se coloca dentro de un popup se debe enviar en las opciones el parametro
   popupOptions: {
        observeChanges: false
     }
   * Ya que el popup se retira del dom si no está visible. ver:
   * https://github.com/mdehoog/Semantic-UI-Calendar/issues/99
   */
  import DateUtils from '@/util/DateUtils'

  export default {
    data () {
      return {}
    },
    props: ['name', 'placeholder', 'value', 'options'],
    mounted () {
      this.textChange = false
      let componentOptions = {
        onChange: (date, text, mode) => {
          this.textChange = true
          this.$emit('update:value', date)
        },
        text: {
          days: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          today: 'Hoy',
          now: 'Ahora',
          am: 'AM',
          pm: 'PM'
        }
      }

      Object.assign(componentOptions, this.options)
      let calConfig = jQuery.extend(true, componentOptions, this.dtOptions)

      this.obj = jQuery(this.$el).calendar(calConfig)
      if (this.value instanceof Date) {
        this.obj.calendar('set date', this.value, true, false)
      } else if (typeof this.value === 'string') {
        this.obj.calendar('set date', DateUtils.backEndStringToDate(this.value), true, false)
      }
    },
    watch: {
      value: function (val) {
        if (!this.textChange) {
          this.obj.calendar('set date', val, true, false)
        }

        this.textChange = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/calendar/calendar.vue